/**
 * Claim form Redux slice helpers.
 * Root state is Immutable; claimForm reducer returns plain objects that are stored as Immutable Maps.
 */
export function selectClaimFormState(state) {
  const slice = state.getIn(['formData']);
  if (!slice) {
    return null;
  }
  return typeof slice.toJS === 'function' ? slice.toJS() : slice;
}

/** Scroll claim UI to top — Layerbar panel when open, otherwise main app shell. */
export function scrollClaimFormToTop() {
  const layerbarPanel = document.querySelector('[data-layerbar-scroll]');
  const appShell = document.querySelector('.App');
  const scrollTarget = layerbarPanel ?? appShell ?? document.scrollingElement;
  scrollTarget?.scrollTo?.({ top: 0, behavior: 'smooth' });
}
